import { render, staticRenderFns } from "./Friday.vue?vue&type=template&id=3f3c0e63"
import script from "./Friday.vue?vue&type=script&lang=js"
export * from "./Friday.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports